var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import Box from '../Grid/Box';
import P from '../Text/P';
/**
 * A formatted text like markdown.
 * Currently we only support splitting into paragraphs, but we will continuedly add more formatting.
 * @param {object} props
 * @param {string} props.text
 * @param {import('../Text/pVariants').PVariants} [props.variant]
 */
export default function FormattedText(_a) {
    var { text, variant } = _a, rest = __rest(_a, ["text", "variant"]);
    if (!text)
        return null;
    return (jsx(Box, Object.assign({}, rest), text === null || text === void 0 ? void 0 : text.split('\n\n').map((p) => (jsx(P, { key: p, variant: variant }, p)))));
}
//# sourceMappingURL=FormattedText.js.map